import React from "react";
import { Grid } from "@material-ui/core";

const Maintenance = ({ filterComponent, tableComponent }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {filterComponent}
      </Grid>
      <Grid item xs={12}>
        {tableComponent}
      </Grid>
    </Grid>
  );
};

export default Maintenance;
